export const getDisplayFileType = (record) => {
  if (record.itemType === 'folder') {
    return 'other';
  }

  const fileName = record.fileName || record.fullPath?.split('/').pop() || '';
  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex <= 0 || dotIndex === fileName.length - 1) {
    return 'other';
  }

  return fileName.slice(dotIndex + 1).toLowerCase();
};
